import moment from 'moment';
export const currentLang = document.querySelector('html')?.getAttribute('lang') || 'sv';
export const setCache = (obj) => localStorage.setItem('bd_cache', JSON.stringify(obj));
export const getCache = () => {
    const c = localStorage.getItem('bd_cache');
    return c ? JSON.parse(c) : null;
};
export const clearCache = () => {
    localStorage.removeItem('bd_cache');
    return getCache() ? false : true;
};
export const switchHeaderType = (state) => {
    const nav = document.querySelector('.js-main-nav');
    const loginBtn = document.querySelector('.js-nav-loginbtn');
    const myPagesBtn = document.querySelector('.js-nav-mybtn');
    if (state) {
        nav?.classList.add('bg-smalt-blue');
        nav?.classList.add('bg-none');
        if (loginBtn) {
            loginBtn.style.display = 'none';
        }
        if (myPagesBtn) {
            myPagesBtn.style.display = 'block';
        }
    }
    else {
        nav?.classList.remove('bg-smalt-blue');
        if (loginBtn) {
            loginBtn.style.display = 'block';
        }
        if (myPagesBtn) {
            myPagesBtn.style.display = 'none';
        }
    }
};
export const resetContactPerson = (contactPerson) => {
    if (contactPerson === null) {
        return {
            first_name: '',
            last_name: '',
            email: '',
            cellphone: ''
        };
    }
    return contactPerson;
};
export const setSnackbar = (response) => {
    let snackbar = {};
    if (response && 'status' in response) {
        snackbar.status = response.status;
        snackbar.message = response.message;
    }
    return snackbar;
};
export const translateTitle = (item) => {
    let title = '';
    if (item && typeof item !== 'string') {
        const currentLangItem = item.find((i) => i.lang === currentLang);
        if (currentLangItem) {
            title = currentLangItem.value;
        }
    }
    else {
        title = item;
    }
    return title;
};
export const getPropById = (baseArray, ids) => {
    let arr = Object.keys(ids).map((id) => ids[id]);
    let results = [];
    if (arr && arr.length > 0) {
        arr.forEach(id => {
            const obj = baseArray.find((i) => i.id === id);
            if (obj) {
                const propName = obj.property_name.find((i) => i.lang === currentLang)?.value;
                if (propName) {
                    results.push(propName);
                }
            }
        });
    }
    return results.join(', ');
};
export const formatDate = (date, format = 'YYYY-MM-DD') => {
    return date.length > 0 ? moment(date).format(format) : null;
};
export const sessionStorageTransfer = (event) => {
    // IE suq
    if (!event) {
        event = window.event;
    }
    // Do nothing if no value to work with
    if (!event.newValue) {
        return;
    }
    if (event.key === 'getSessionStorage') {
        // Tab asked for the sessionStorage -> send it
        localStorage.setItem('bd_cache', JSON.stringify(sessionStorage));
        // The tab should now have it, so we're done with it.
        localStorage.removeItem('bd_cache');
    }
    else if (event.key === 'bd_cache') {
        // Another tab sent data <- get it
        var data = JSON.parse(event.newValue);
        for (const key in data) {
            sessionStorage.setItem(key, data[key]);
        }
        location.reload();
    }
};
export const isNumeric = (str) => !isNaN(Number(str));
export const deepEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (areObjects && !deepEqual(val1, val2) ||
            !areObjects && val1 !== val2) {
            return false;
        }
    }
    return true;
};
export const isObject = (object) => {
    return object != null && typeof object === 'object';
};
export const commaSeperatedStringToArray = (str) => {
    return str.split(',').map((i) => i.trim());
};
